// extracted by mini-css-extract-plugin
export default {"productTitleBox":"ProductTitle_productTitleBox__Gu890","productTitle":"ProductTitle_productTitle__vCZNM"};